import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { RoleplayService, StepperContent } from '../../../service/roleplay/roleplay.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'app-roleplay-step3',
    templateUrl: './roleplay-step3.component.html',
    styleUrl: '../../../../assets/css/roleplay.scss',
    standalone: false
})
export class RoleplayStep3Component {
  step3Form: FormGroup;
  sharedData: any = {};
  subscription: Subscription;
  color: string = '#e8e6e3';
  scenario_name: string = "";
  doctors = [
    { name: "Dr.Bruno", dept: "Neuro", age: "45 Yrs", image: "neuro_pic.png" },
  ];
  customerValues1 = [
    { id: 'Hemodynamic instability to enable complete revascularization', label: 'Hemodynamic instability to enable complete revascularization', checked: false },
    { id: 'it helps avoid procedural complications', label: 'it helps avoid procedural complications', checked: false }
  ];
  concernsAbout1 = [
    { id: 'Concerns about vascular complications due to large bore axix', label: 'Concerns about vascular complications due to large bore axix', checked: false },
    { id: 'patient anatomical challenges that make Impella insertion challenging', label: 'patient anatomical challenges that make Impella insertion challenging', checked: false }
  ];

  relationshipHistory1 = [{ id: "Customer's use of the product is declining", label: "Customer's use of the product is declining", checked: false },
  { id: 'Sales rep believes customer could use impella more', label: "Sales rep believes customer could use impella more", checked: false },]

  constructor(public Router: Router, private fb: FormBuilder, private sharedService: RoleplayService,
    private toastrService: ToastrService,private dialog: MatDialog) {
  }
  data: any = [];
  isEditMode: boolean;
  getData: any = {};

  ngOnInit(): void {

    this.sharedService.editMode$.subscribe(mode => {
      this.isEditMode = mode;
    });
    this.step3Form = this.fb.group({
      customerValues: this.fb.array([]),
      concernsAbout: this.fb.array([]),
      relationshipHistory: this.fb.array([]),
      valueInputs: this.fb.array([]),
      concernInputs: this.fb.array([])
    });
    if (this.isEditMode) {
      this.sharedService.data$.subscribe({
        next: data => {
          this.data = data;
          const updatedValueData = this.filterOutData(this.data, 'product_value')
          const updatedConcernData = this.filterOutData(this.data, 'product_concern')
          this.scenario_name = this.data[0].scenario_name;
          const PreviousvaluesData = this.ifPreviousSelectedValuesData('product_value');
          const PreviousAboutData = this.ifPreviousSelectedValuesData('product_concern');

          if (this.sharedService.rolePlayScenarioData.step3) {
            this.setDoctorsData(PreviousvaluesData, PreviousAboutData);
          } else {
            this.setDoctorsData(updatedValueData, updatedConcernData);
          }
        },
        error: error => console.error('Error receiving data', error),
        complete: () => console.log('Data stream completed')
      });
    } else {
      this.subscription = this.sharedService.data$$.subscribe(response => {
        const PreviousvaluesData = this.ifPreviousSelectedValuesData('product_value');
        const PreviousAboutData = this.ifPreviousSelectedValuesData('product_concern');

        if (this.sharedService.rolePlayScenarioData.step3) {
          this.setDoctorsData(PreviousvaluesData, PreviousAboutData);
        } else {
          this.setDoctorsData(response['product_value'], response['product_concern']);
        }
      }
      );
    }
  }

  filterOutData(data, value) {
    return data[0].meta_data.filter(item => item.roleplay_metadata_type === value).map(items => {
      const { roleplay_metadata_val: name, id } = items;
      return { name, id }
    });
  }

  ifPreviousSelectedValuesData(value) {
    if (this.sharedService.rolePlayScenarioData.roleplay_metadata.length) {
      const metaDataArray = this.sharedService.rolePlayScenarioData.roleplay_metadata;
      const objectiveMetaDataArray = metaDataArray.filter(data => {
        return data.type_name === value;
      });
      const updatedData = objectiveMetaDataArray.map(item => {
        const { type_value } = item;
        return { name: type_value };
      });
      return updatedData;
    }
    return [];
  }

  groupByMetadataType() {
    return this.data[0].meta_data.reduce((acc, item) => {
      const { roleplay_metadata_type } = item;
      if (!acc[roleplay_metadata_type]) {
        acc[roleplay_metadata_type] = [];
      }
      const { id, roleplay_metadata_val: name } = item;
      acc[roleplay_metadata_type].push({ id, name });
      return acc;
    }, {});
  }
  setDoctorsData(customerValues: any[], concernsAbout: any[]): void {
    const customerValuesFGs = customerValues.map(values => this.fb.control(values.name));
    const customerValuesFormArray = this.fb.array(customerValuesFGs);
    this.step3Form.setControl('customerValues', customerValuesFormArray);
    const concernsAboutFGs = concernsAbout.map(values => this.fb.control(values.name));
    const concernsAboutFormArray = this.fb.array(concernsAboutFGs);
    this.step3Form.setControl('concernsAbout', concernsAboutFormArray);
  }

  get valueInputs() {
    return this.step3Form.get('valueInputs') as FormArray;
  }

  get concernInputs() {
    return this.step3Form.get('concernInputs') as FormArray;
  }

  get customerValues(): FormArray {
    return this.step3Form.get('customerValues') as FormArray;
  }

  get concernsAbout(): FormArray {
    return this.step3Form.get('concernsAbout') as FormArray;
  }


  addValueInput() {
    this.customerValues.push(this.fb.control(''));
  }

  addConcernInput() {
    this.concernsAbout.push(this.fb.control(''));
  }
  removeInput(index: number, type: string): void {
    switch (type) {
      case 'V':
        this.customerValues.removeAt(index);
        break;
      case 'C':
        this.concernsAbout.removeAt(index);
        break;
    }
  }

  retainSelectedMetaData() {
    this.sharedService.rolePlayScenarioData.roleplay_metadata =
      this.sharedService.rolePlayScenarioData.roleplay_metadata.filter(item => item.type_name !== 'product_value' &&
        item.type_name !== 'product_concern');
    let custVal = this.step3Form.value.customerValues;
    if (custVal.length > 0) {
      custVal = custVal.filter(item => item?.trim());
      custVal.forEach(data => {
        this.sharedService.rolePlayScenarioData.roleplay_metadata.push(
          {
            type_name: "product_value",
            type_value: data
          }
        )
      })
    }
    let conAbout = this.step3Form.value.concernsAbout;
    if (conAbout.length > 0) {
      conAbout = conAbout.filter(item => item?.trim());
      conAbout.forEach(data => {
        this.sharedService.rolePlayScenarioData.roleplay_metadata.push(
          {
            type_name: "product_concern",
            type_value: data
          }
        )
      })
    }
    this.sharedService.rolePlayScenarioData.step3 = true;
  }

  goToStep(id:number){
    const stepper_data:StepperContent = this.sharedService.stepperContent.find(stepper=>stepper.stepId == id);
    this.changeStepper(stepper_data);
  }

  changeStepper(stepper_data: StepperContent) {
    console.log('Step3 : changeStepper: ', stepper_data);
    const current_step_id = 3;
    if (this.step3Form.valid || stepper_data.stepId < current_step_id) {
      this.retainSelectedMetaData();
      this.sharedService.changeStep(stepper_data);
    } else {
      this.toastrService.error('Invalid Form')
    }
  }
  goBack() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: { message: 'You will lose all changes. Do you really want to leave?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }
      this.Router.navigate(['/app-trainee-dasboard'], { skipLocationChange: true });
    });
  }
}
